import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Button, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';


function SkilsForm({ register, handleSubmit, activeStep, errors, steps, isLoading, setIsLoading, setValue }) {
    const [maxTravelDistance, setMaxTravelDistance] = useState(null);
    const [verifyCaptcha, setVerifyCaptcha] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [openNotify, setOpenNotify] = useState(false);
    const [isTravelDistanceKmEnable, setIsTravelDistanceKmEnable] = useState(true);
    const [availabilityDate, setAvailabilityDate] = useState(new Date())

    const handleAvailabilityDateChange = (e) => {
        setAvailabilityDate(e.target.value)
      }

    const handleRegister = () => {
        // if (verifyCaptcha) {
        setIsLoading(true);
        handleSubmit();
        // } else {
        //     setNotificationMessage('Please verify the captcha first!');
        //     handleOpenNotification();
        // }
    }

    const handlemaxTravelDistanceFromHomeChange = (e) => {
        setMaxTravelDistance(e.target.value);
    }

    useEffect(() => {
        if (maxTravelDistance === 'I am willing to move (temporary) for a new product / assignment') {
            setIsTravelDistanceKmEnable(true);
            setValue('maxTravelDistanceFromHomeKm', '');
        } else if (maxTravelDistance === 'I want a maximum single travel distance of: ') {
            setIsTravelDistanceKmEnable(false);
        }
    }, [maxTravelDistance]);

    const handleOpenNotification = () => {
        setOpenNotify(true);
    };

    const handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenNotify(false);
    };

    const handleCaptchaOnLoad = () => {
        // console.log('Captcha load successfully.');
    };

    const handleCaptchaVerification = (response) => {
        if (response) {
            setVerifyCaptcha(true);
        }
        else {
            setVerifyCaptcha(false);
        }
    };

    return (
        <>
            <div className="skilsForm pt-1 pb-3">
                <div className="row">
                    <div className="col-md-8 mb-2">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="login__textboxLabel"><strong>Desired specific fucntion(s) + your unique skills</strong></label> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                    <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.functionOrUniqueSKills })}
                                        name="functionOrUniqueSKills" placeholder="Unique Skills" autoComplete="none"
                                        ref={register({ required: 'Please enter your skills!' })} />
                                    <small className="form-text text-danger">{errors.functionOrUniqueSKills && errors.functionOrUniqueSKills.message}</small>
                                </div>
                            </div>
                            <div className="col-md-12 mt-2">
                                <div className="alert alert-warning" role="alert">
                                    <p>Name your desired function(s) as specifically as possible, also mention your best skills.</p>
                                    <p>Examples. Back-end developer PHP, MySQL, CSS, HTML, System engineer / Network engineer, Windows. VMWare, SQL Server</p>
                                    <p>This title is public so don't enter any private details like name, email, phone</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="login__textboxLabel"><strong>Your personal bio (non mandatory)</strong></label>
                            <textarea type="text" cols={4} rows={4} className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.personalBio })}
                                name="personalBio" placeholder="Personal bio" autoComplete="none"
                                ref={register}></textarea>
                        </div>
                    </div>
                </div>
                {/* <div className="row mt-2">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label className="login__textboxLabel"><strong>Product Level</strong></label> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                            <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.productLevel })} aria-label="Default select example"
                                name="productLevel" ref={register({
                                    required: 'Please select any product level!',
                                    validate: {
                                        defaultValue: value => value !== "Select Level" || 'Please select name title!'
                                    }
                                })} defaultValue="Select Level">
                                <option value="Select Level">Select Level</option>
                                <option value="University">University</option>
                            </select>
                            <small className="form-text text-danger">{errors.productLevel && errors.productLevel.message}</small>
                        </div>
                    </div>
                </div> */}
                <div className="row mt-2">
                    {/* <div className="col-md-12 mb-3">
                        <div className="form-group">
                            <label className="login__textboxLabel"><strong>Your current career level</strong></label><span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span><br></br>
                            <FormControl component="fieldset">
                                <RadioGroup aria-label="careerLevel" name="careerLevel">
                                    <FormControlLabel value="Junior" control={<Radio className="skilsForm__radioBtn" />}
                                        label="Junior (None or only a few years of experience, needs to learn a lot, needs coaching)"
                                        name="currentCareerLevel"
                                        inputRef={register} />
                                    <FormControlLabel value="Medior" control={<Radio className="skilsForm__radioBtn" />}
                                        label="Medior (Quite a few years of experience, can work on his own, works well together with colleagues, has sufficient knowledge)"
                                        name="currentCareerLevel"
                                        inputRef={register} />
                                    <FormControlLabel value="Senior" control={<Radio className="skilsForm__radioBtn" />}
                                        label="Senior (Years of experience, coaches othe colleagues, has vision, puts out pillars, lots of knowledge)"
                                        name="currentCareerLevel"
                                        inputRef={register} />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div> */}
                    {/* <div className="col-md-12 mb-3">
                        <div className="form-group">
                            <label className="login__textboxLabel"><strong>Preferred contract (non mandatory)</strong></label><br></br>
                            <FormControl component="fieldset">
                                <FormGroup row>
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="Capsule"
                                        name="preferredContract.capsule"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="Freelance"
                                        name="preferredContract.freelance"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="Remote"
                                        name="preferredContract.remote"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="Temporary Contract"
                                        name="preferredContract.temporaryContract"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="Internship"
                                        name="preferredContract.internship"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="Syrup"
                                        name="preferredContract.syrup"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="Traineeship"
                                        name="preferredContract.traineeship"
                                        inputRef={register}
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>
                    </div> */}
                    {/* <div className="col-md-12 mb-3">
                        <div className="form-group">
                            <label className="login__textboxLabel"><strong>Number of hours per week (non mandatory)</strong></label><br></br>
                            <FormControl component="fieldset">
                                <FormGroup row>
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="8 hrs"
                                        name="hourPerWeek.EightHours"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="16 hrs"
                                        name="hourPerWeek.SixteenHours"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="24 hrs"
                                        name="hourPerWeek.TwentyFourHours"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="32 hrs"
                                        name="hourPerWeek.ThirtyTwoHours"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="36 hrs"
                                        name="hourPerWeek.ThirtySixHours"
                                        inputRef={register}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox className="registerEmp__acceptTerms" />}
                                        label="40 hrs"
                                        name="hourPerWeek.FourtyHours"
                                        inputRef={register}
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>
                    </div> */}

                    {/* <div className="col-md-12 mb-3">
                        <div className="form-group">
                            <label className="login__textboxLabel"><strong>Max. travel distance from home (non mandatory)</strong></label><br></br>
                            <FormControl component="fieldset">
                                <RadioGroup aria-label="careerLevel" name="careerLevel">
                                    <FormControlLabel value="I want a maximum single travel distance of: " control={<Radio className="skilsForm__radioBtn" />}
                                        label="I want a maximum single travel distance of: "
                                        name="maxTravelDistanceFromHome"
                                        inputRef={register} onChange={handlemaxTravelDistanceFromHomeChange} />
                                    <input type="text" className={classNames("form-control registerEmp__textbox skilsForm__maxTravelDistanceKmInput", { "is-invalid": errors.maxTravelDistanceFromHomeKm })}
                                        name="maxTravelDistanceFromHomeKm" placeholder="Distance" autoComplete="none"
                                        ref={register({
                                            required: maxTravelDistance ?
                                                maxTravelDistance === "I want a maximum single travel distance of: " ? 'Please enter distance in Km!' : false : null
                                        })} disabled={isTravelDistanceKmEnable} />
                                    <small className="form-text text-danger">{errors.maxTravelDistanceFromHomeKm && errors.maxTravelDistanceFromHomeKm.message}</small>
                                    <FormControlLabel value="I am willing to move (temporary) for a new product / assignment" control={<Radio className="skilsForm__radioBtn" />} className="skilsForm__temporaryMove"
                                        label="I am willing to move (temporary) for a new product / assignment"
                                        name="maxTravelDistanceFromHome"
                                        inputRef={register} onChange={handlemaxTravelDistanceFromHomeChange} />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div> */}
                    {/* <div className="col-md-4 mb-3">
                        <div className="form-group">
                            <label className="login__textboxLabel"><strong>Available From (non mandatory)</strong></label><br></br>
                            <FormControl component="fieldset">
                                <RadioGroup aria-label="careerLevel" name="careerLevel">
                                    <FormControlLabel value="Available immediately" control={<Radio className="skilsForm__radioBtn" />}
                                        label="Available immediately"
                                        name="availableFrom"
                                        inputRef={register} />
                                    <FormControlLabel value="Available From" control={<Radio className="skilsForm__radioBtn" />}
                                        label="Available From:"
                                        name="availableFrom"
                                        inputRef={register} />
                                    <DatePickerComponent
                                        id="availableFromDate"
                                        value={availabilityDate}
                                        cssClass="e-outline"
                                        onChange={(e) => handleAvailabilityDateChange(e)}
                                        ref={register}
                                        format="dd/mm/yyyy"
                                        className={classNames('form-control registerEmp__textbox', {
                                            'is-invalid': errors.availableFromDate,
                                        })}
                                        name="availableFromDate"
                                        min={availabilityDate}
                                    />
                                    <small className="form-text text-danger">{errors.availableFromDate && errors.availableFromDate.message}</small>
                                    <FormControlLabel value="Open for a better offer" control={<Radio className="skilsForm__radioBtn" />} className="skilsForm__temporaryMove"
                                        label="Open for a better offer"
                                        name="availableFrom"
                                        inputRef={register} />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div> */}
                    <div className="col-md-4 mb-3">
                        <div className="form-group">
                            <label className="login__textboxLabel">Your Password</label> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                            <input type="password" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.password })}
                                name="password" placeholder="Your Password" autoComplete="none"
                                ref={register({ required: 'Please enter your password!' })} />
                            <small className="form-text text-danger">{errors.password && errors.password.message}</small>
                        </div>
                    </div>
                </div>

                <div className="row pb-3">
                    <div className="col-md-12 text-center mt-2">
                        <Button onClick={handleRegister} className="multiStepRegister__btnLogin" variant="contained"
                            disabled={activeStep === steps.length ? true : false}>
                            {activeStep === steps.length ? 'All Steps Complete' : activeStep === steps.length - 1 ?
                                isLoading ? <CircularProgress size={18} /> : 'Register' : 'Next'}
                        </Button>
                    </div>
                </div>
            </div>

            <Snackbar open={openNotify} autoHideDuration={6000} onClose={handleCloseNotification}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert onClose={handleCloseNotification} severity="error">
                    {notificationMessage}
                </Alert>
            </Snackbar>
        </>
    )
}

export default SkilsForm
